import { ServiceInterface } from "../service.interface";
import { StorageService } from "../storage";
import { translations as diskTranslations } from "../../i18n/translations";
import { createContext } from "react";
import { Environment } from "../../environment";

export const PreferenceServiceContext = createContext<PreferenceService>(
  null as any
);

export class PreferenceService implements ServiceInterface {
  public context = PreferenceServiceContext;

  constructor(private storageService: StorageService) {}

  public ACTIVE_CITY_ID =
    this.storageService.getPreference<string>("ACTIVE_CITY_ID");

  public HAS_SEEN_INTRODUCTION = this.storageService.getPreference(
    "HAS_SEEN_INTRODUCTION",
    false
  );

  public HAS_FINISHED_MAP_ONBOARDING = this.storageService.getPreference(
    "HAS_FINISHED_MAP_ONBOARDING",
    false
  );

  public STORED_TRANSLATIONS = this.storageService.getPreference(
    "STORED_TRANSLATIONS",
    diskTranslations
  );

  public PREF_LANGUAGE = this.storageService.getPreference<string | undefined>(
    "PREF_LANGUAGE",
    undefined
  );

  public NAVIGATION_STATE = this.storageService.getPreference<any>(
    !__DEV__
      ? `NAVIGATION_STATE_${Environment.environmentName}_${Environment.version}`
      : `NAVIGATION_STATE_${Environment.environmentName}_${Environment.version}.0` // Use last digit to bust cache
  );

  public async serviceWillMount() {
    const promises: Promise<any>[] = [];
    for (const value of Object.values(this)) {
      if ("ready$" in value) {
        promises.push(value.ready$);
      }
    }
    return Promise.all(promises);
  }
}
